import React from 'react';

/** Any mark with a holder's face as its seal at the lower right: a realm made for one recipient
 *  wears the face of the one it is for. */
export function SealedMark({ size = 50, mark, seal }) {
    return (
        <span className="nx-contract nx-sealed" style={{ '--contract-size': `${size}px` }} aria-hidden="true">
            <span className="nx-sealed__mark">{mark}</span>
            {seal && <span className="nx-contract__seal">{seal}</span>}
        </span>
    );
}

// AN EXPOSURE PROFILE'S MARK: a contract, sealed with the face of whoever holds it.
// The page is the agreement (what they get, from which realms, until when); the
// seal at its lower right says with whom: an app's logo, a person's photo, a
// group's glyph. Flat, as Nucleus is: hairline strokes, the seal ringed in the
// surface colour rather than lifted by a shadow.
export default function ContractMark({ size = 64, seal, dim }) {
    return (
        <span className={`nx-contract${dim ? ' is-dim' : ''}`} style={{ '--contract-size': `${size}px` }} aria-hidden="true">
            <svg className="nx-contract__page" viewBox="0 0 44 54" fill="none">
                <path className="nx-contract__sheet" d="M1.5 1.5h29l12 12v39h-41z" />
                <path className="nx-contract__fold" d="M30.5 1.5v12h12" />
                <path className="nx-contract__lines" d="M8 18h16M8 24h27M8 30h27M8 36h20" />
                <path className="nx-contract__sign" d="M8 46.5c2.4-4.6 4.2-4.6 4.8-.6.5 3.2 2.3 3 3.8-.4 1.2-2.6 2.6-2.4 3.3.2" />
            </svg>
            {seal && <span className="nx-contract__seal">{seal}</span>}
        </span>
    );
}
